import { Button } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _SearchBox(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, search } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [searchInput, setSearchInput] = useState("")

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleChange(event) {
        setSearchInput(event.target.value)
    }

    function onFinish(event) {
        event.preventDefault()
        search(searchInput)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <form className="search-form" onSubmit={onFinish}>
                <input
                    className="search-input"
                    value={searchInput}
                    onChange={handleChange}
                    placeholder="Dove vuoi cercare?"
                />
                <Button htmlType="submit" className="icon-button">
                    <img
                        src="/assets/icons/search.svg"
                        alt="search icon"
                        width={20}
                        height={20}
                    />
                </Button>
            </form>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_SearchBox.propTypes = {
    className: PropTypes.string.isRequired,
}

_SearchBox.defaultProps = {}

// ----------------------------------------------------------------------------

const SearchBox = styled(_SearchBox)`
    & {
        position: relative;
        display: inline-block;
        .icon-button {
            position: absolute;
            top: calc(
                (
                        ${(props) => props.theme.spacing.searchBoxMenuHeight} -
                            ${(props) =>
                                props.theme.spacing.searchBoxMenuButton}
                    ) / 2
            );
            right: calc(
                (
                        ${(props) => props.theme.spacing.searchBoxMenuHeight} -
                            ${(props) =>
                                props.theme.spacing.searchBoxMenuButton}
                    ) / 2
            );
            width: ${(props) => props.theme.spacing.searchBoxMenuButton};
            height: ${(props) => props.theme.spacing.searchBoxMenuButton};
            border: 0;
            border-radius: 50%;
            background: ${(props) => props.theme.colors.buttonBackground};
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${(props) => props.theme.colors.light};
            span {
                padding-left: ${(props) => props.theme.spacing.padding};
            }
        }
        .search-input {
            font-size: ${(props) => props.theme.font.text.size};
            line-height: ${(props) => props.theme.font.text.height};
            border: 1px solid ${(props) => props.theme.colors.grayBorder};
            height: ${(props) => props.theme.spacing.searchBoxMenuHeight};
            min-width: ${(props) => props.theme.spacing.searchBoxMenuWidth};
            border-radius: calc(
                ${(props) => props.theme.spacing.searchBoxMenuHeight} / 2
            );
            padding-left: calc(
                ${(props) => props.theme.spacing.searchBoxMenuHeight} / 2
            );
        }
        @media screen and (max-width: 580px) {
            display: none;
        }
    }
`
// ----------------------------------------------------------------------------

export default SearchBox
